export enum playInTypes {
  SET_PLAY_IN = 'SET_PLAY_IN',
  PLAY_IN_LISTENERS_ADDED = 'PLAY_IN_LISTENERS_ADDED',
  REMOVE_PLAY_IN_DOC = 'REMOVE_PLAY_IN_DOC',
  FETCH_PLAY_IN_LIST_ERROR = 'FETCH_PLAY_IN_LIST_ERROR',
  FETCH_PLAY_IN_LIST_SUCCESS = 'FETCH_PLAY_IN_LIST_SUCCESS',
  ADD_TO_PLAY_IN_LIST = 'ADD_TO_PLAY_IN_LIST',
  ADD_TO_PLAY_IN_LIST_ERROR = 'ADD_TO_PLAY_IN_LIST_ERROR',
  ADD_TO_PLAY_IN_LIST_SUCCESS = 'ADD_TO_PLAY_IN_LIST_SUCCESS',
  REMOVE_FROM_PLAY_IN_LIST = 'REMOVE_FROM_PLAY_IN_LIST',
  REMOVE_FROM_PLAY_IN_LIST_ERROR = 'REMOVE_FROM_PLAY_IN_LIST_ERROR',
  REMOVE_FROM_PLAY_IN_LIST_SUCCESS = 'REMOVE_FROM_PLAY_IN_LIST_SUCCESS'
}
